











import Vue from 'vue'

import selectSearchable from '@/components/controls/select/select-searchable/select-searchable.vue'
import { DefaultListModel } from '@/components/controls/select/select-searchable/types'
import { MerchantInterfaces } from '@/api/merchantInterfaces'
import { Okpd2Model } from '@/types/common'

export default Vue.extend({
    name: 'okpd2-selector',
    components: {
        selectSearchable
    },
    props: {
        item: Object as () => Okpd2Model
    },
    mounted() {
        this.$root.$on('getCodesSuggestion', function(this: any, name: string) {
            this.getOkpd2Suggestion(name);
        }.bind(this));
        this.$root.$on('clearOkpd2List', () => {
            this.list = [] as Okpd2Model[];
            this.currentValue.Value = '';
            this.currentValue.Name = '';
            this.keyword = '';
        });
        this.currentValue.Name = this.item.Name
        this.currentValue.Value = this.item.Code
    },
    data() {
        return {
            list: [] as Okpd2Model[],
            keyword: '',
            currentValue: {
                Name: '',
                Value: '',
                Selected: false
            } as DefaultListModel
        }
    },
    methods: {
        async search(keyword: string) {
            if (keyword === this.keyword) return;
            this.keyword = keyword;
            if (!keyword || keyword.length < 1) {
                this.list = [] as Okpd2Model[];
                return;
            }
            const { data } = await MerchantInterfaces.getOneOrManyOkpdByKeyword(keyword);
            this.list = Array.isArray(data) ? data.slice(0, 10) : [data];
        },
        async getOkpd2Suggestion(name: string) {
            if (!name || name.length < 1) return;
            this.$root.$emit('loadingOkpd2', true);

            const { data } = await MerchantInterfaces.getOkpd2Suggestions(escape(name));
            const temp = (data && Array.isArray(data)) ? data.slice(0, 10) : [];

            this.list = temp.map((item) => {
                return {
                    Code: item.code ? item.code : '',
                    Name: item.name ? item.name : '',
                }
            });

            if (this.list.length > 0) {
                if (this.$store.state.currentPosition.Okpd2
                    && this.$store.state.currentPosition.Okpd2.length > 0
                    && this.$store.state.currentPosition.Okpd2Name
                    && this.$store.state.currentPosition.Okpd2Name.length > 0)
                {
                    this.currentValue.Name  = this.$store.state.currentPosition.Okpd2Name;
                    this.currentValue.Value = this.$store.state.currentPosition.Okpd2;
                } else {
                    this.currentValue.Name  = this.list[0].Code + ' ' + this.list[0].Name;
                    this.currentValue.Value = this.list[0].Code;
                }
                this.keyword = '';
                this.$emit('select', this.currentValue);
            }
        },
        select(data: DefaultListModel) {
            if (!data.Name || !this.list || this.list.length < 1) return;
            this.currentValue = data;
            const currentItem = this.list.find((item) => item.Code === data.Value)
            if(currentItem && currentItem.Name) {
                this.currentValue.Value = currentItem.Code;
                this.currentValue.Name = currentItem.Code + ' ' + currentItem.Name;
            }
            this.$emit('select', this.currentValue);
        },
    },
    computed: {
        okpd2List(): DefaultListModel[] {
            if (!this.list || this.list.length < 1) {
                this.$root.$emit('loadingOkpd2', false);
                return [] as DefaultListModel[];
            }
            const resultList = this.list.map((item) => {
                return {
                    Value: item.Code ? item.Code : '',
                    Name: item.Name ? (item.Code + (item.Code.length > 0 ? ' ' : '') + item.Name) : '',
                    Selected: false
                }
            });
            this.$root.$emit('loadingOkpd2', false);
            return resultList;
        },
        placeholder(): string {
            return this.currentValue.Name ? '' : 'Выберите код из списка или введите свой';
        }
    },
    watch: {
        'item.Name'() {
            this.keyword = '';
            if (!this.item.Code || !this.item.Name) {
                this.item.Code = this.currentValue.Value.toString();
                this.item.Name = this.currentValue.Name;
            }
            if (!this.currentValue.Name) {
                this.currentValue.Value = this.item.Code;
                this.currentValue.Name = this.item.Code + ' ' + this.item.Name;
            }
        }
    }
})
